/* unplugin-vue-components disabled */import { render } from "./jixuan.vue?vue&type=template&id=403294f8&scoped=true"
import script from "./jixuan.vue?vue&type=script&lang=js"
export * from "./jixuan.vue?vue&type=script&lang=js"

import "./jixuan.vue?vue&type=style&index=0&id=403294f8&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403294f8"]])

export default __exports__